module.exports = __webpack_public_path__ + "static/media/text_icon_rectangle.58b284b8.svg";